/** User Settings Enum */
export enum SettingsKey {
  /** @deprecated use firebase.auth() for get email */
  Email = "email",
  /** @deprecated use firebase.auth() for get token */
  Token = "token",
  Company = "company",
  Id = "id",
  Firstname = "firstname",
  Lastname = "lastname",
  Position = "position",
  DefectCounter = "defectcounter",
  Tenant = "tenantid",
  Tier = "tier",
  /** Save as number from 0 to 100 */
  Quality = "quality",
  ReportQuality = "report-quality",
  ReportErrorMessage = "report-error-message",
  HelpTipsQuickSearch = "helptipsquicksearch",
  Database = "database",
  BusinessLogo = "businesslogo",
  BusinessAddress = "businessaddress",
  /**
   * Save as 1 (true) or 0 (false)
   * @since 1.2.6
   */
  SaveImagesToGallery = "save-images-to-gallery",
  /**
   * Toggle options 0 or 1
   * @since 1.2.7
   */
  ReportShowCompanyName = "report-show-company-name",
  ReportShowProjectImage = "report-show-project-image",
  ReportShowProjectRef = "report-show-project-ref",
  ReportShowAddress = "report-show-address",
  ReportShowClient = "report-show-client",
  ReportShowPreparedBy = "report-show-prepared-by",
  ReportShowNotes = "report-show-notes",
  ReportShowSignatures = "report-show-signatures",
  /** Where notes and signature are shown */
  ReportNotesPosition = "report-notes-position",
  /** Title of report */
  ReportTextTitle = "report-text-title",
  /** Summary notes */
  ReportTextNotes = "report-text-notes",
  /** Report accent colour */
  ReportAccentColor = "report-accent-color",
  // DEFECT LIST BLOCK OPTIONS
  ReportShowDefectOrientation = "report-show-defect-orientation",
  ReportShowDefectNumber = "report-show-defect-number",
  ReportShowDefectStatus = "report-show-defect-status",
  ReportShowDefectArea = "report-show-defect-area",
  ReportShowDefectElement = "report-show-defect-element",
  ReportShowDefectIssue = "report-show-defect-issue",
  ReportShowDefectAssignment = "report-show-defect-assignment",
  ReportShowDefectComments = "report-show-defect-comments",
  ReportShowDefectActivity = "report-show-defect-activity",

  /** @since 2.7.0 */
  ReportShowDefectPriority = "report-show-defect-priority",
  /** @since 2.7.0 */
  ReportShowDefectDuedate = "report-show-defect-duedate",
  /** @since 2.7.0 */
  ReportShowDefectPhotoMeta = "report-show-photo-metadata",
  /** @since 2.7.0 */
  ReportShowDefectQrCode = "report-show-defect-qr-code",

  /**
   * Sync options
   * - "0" false,
   * - "1" true
   * @since 1.3.0
   */
  EnableAutoSync = "enable-auto-sync",
  /**
   * Stringified number array of selected status types
   * e.g. `[0,2]` new and completed
   * @since 1.4.0
   */
  ListFilterStatus = "list-filter-status",
  /**
   * Tracking enabled/disabled state of user
   * @since 1.4.0
   */
  Enabled = "enabled",
  /**
   * Total defects available to user based on last login
   * @since 1.4.0
   */
  DefectLimit = "defect-limit",
  /** @since 1.4.0 */
  Admin = "admin",
}

/** Payment Tier Enum */
export enum SettingsPaymentTier {
  Free = 0,
  Premium = 1,
  Enterprise = 2,
}

/** Settings interface */
export interface Settings {
  id?: number;
  key: string;
  setting: string;
}

/** Firestore counter settings interface */
export interface ISettingsFireStoreCounter {
  date: string;
  counter: number | any;
}
/** Settings counter interface */
export interface SettingsCounter extends ISettingsFireStoreCounter {
  offlineCounter: number;
}

/**
 * Create and manage SettingsCounter object
 * Pass in JSON.Stringified setting to create with values
 */
export class SettingsCounterObj {
  offlineCounter: number = 0;
  date: string = "";
  counter: number = 0;

  constructor(settingsJson?: string) {
    this.parse(settingsJson);
  }

  /** Parse the SettingsCounter Settings Type */
  parse(settingsJson?: string): void {
    if (settingsJson) {
      const counter: SettingsCounter = JSON.parse(settingsJson);
      this.offlineCounter = counter.offlineCounter;
      this.date = counter.date;
      this.counter = counter.counter;
    } else {
      this.offlineCounter = 0;
      this.date = new Date().toISOString();
      this.counter = 0;
    }
  }

  /**
   * stringify the Settings storage object
   * @returns {SettingsCounter} SettingsCounter in stringified format
   */
  stringify(): string {
    const outputObj: SettingsCounter = {
      offlineCounter: this.offlineCounter,
      date: this.date,
      counter: this.counter,
    };
    return JSON.stringify(outputObj);
  }

  /** @returns total count off/online */
  total(): number {
    return this.counter + this.offlineCounter;
  }
}
